import Screenshot1 from 'src/assets/img/screenshot-1.svg'
import Screenshot2 from 'src/assets/img/screenshot-2.svg'
import Screenshot3 from 'src/assets/img/screenshot-3.svg'
import Screenshot4 from 'src/assets/img/screenshot-4.svg'
import QoreidIcon from 'src/assets/img/qoreid-icon.png'
import BankinglyIcon from 'src/assets/img/bankingly-icon.png'
import EbanqoIcon from 'src/assets/img/ebanqo-icon.png'
import UserIcon from 'src/assets/img/cat-user-icon.svg'
import LoanIcon from 'src/assets/img/cat-loan-icon.svg'
import ChatIcon from 'src/assets/img/cat-chat-icon.svg'
import VerificationIcon from 'src/assets/img/cat-verification-icon.svg'
import QoreidLogo from 'src/assets/img/qoreid-discover.svg'
import BankinglyLogo from 'src/assets/img/bankingly-discover.svg' 
import EbanqoLogo from 'src/assets/img/ebanqo-discover.svg'
import QoreLogo from 'src/assets/img/qore-discover.svg'
import BankinglyLogoSm from 'src/assets/img/bankingly-logo-sm.svg'
import EbanqoLogoSm from 'src/assets/img/ebanqo-logo-sm.svg'
import QoreidLogoSm from 'src/assets/img/qoreid-logo-sm.svg'

export const apps = [
    QoreidLogo,
    BankinglyLogo,
    EbanqoLogo,
    QoreLogo,
    BankinglyLogo,
    EbanqoLogo,
    QoreLogo
]

export const categories = [
    {bgColor: '#D9FFFC', name: 'Platform & Admin', iconBgColor: '#3EDCCF', icon: UserIcon},
    {bgColor: '#FECAFF', name: 'Chat bot', iconBgColor: '#FC81FF', icon: ChatIcon},
    {bgColor: '#CCFFBB' , name: 'ID Verification', iconBgColor: '#79D05D', icon: VerificationIcon},
    {bgColor: '#D8D8FF', name: 'Loan Insurance', iconBgColor: '#8888FF', icon: LoanIcon},
    {bgColor: '#C7C7C8', name: 'Customer Insurance', iconBgColor: '#919192', icon: LoanIcon},
    {bgColor: '#FECAFF', name: 'Chat bot', iconBgColor: '#FC81FF', icon: ChatIcon},
    {bgColor: '#CCFFBB' , name: 'ID Verification', iconBgColor: '#79D05D', icon: VerificationIcon},
]

export const sampleProducts = [
    {
        serviceCategoryId: '',
        serviceProviderId: '',
        name: 'Bankingly',
        description: 'Bankingly online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        features: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor',
        logo: '',
        logoUrl: BankinglyIcon,
        tooltip: '',
        screenshots: '',
        screenshotUrls: [],
        configureSetupFee: false,
        setupFee: 600,
        usageGuide: 'www.usageguide.com',
        termsAndConditions: '',
        isPublished: false,
        websiteUrl: 'www.test.com',
        installed: false,
        productStatistic: {
            productId: '',
            installation: 0,
            averageRating: 4,
            totalRatings: 0,
            numberOfRatings: 0,
            id: '',
            dateCreated: '2024-10-08T17:27:14.705Z',
            dateModified: '2024-10-08T17:27:14.705Z',
            status: '',
            createdBy: '',
            createdByIp: '',
            modifiedBy: '',
            modifiedByIp: ''
        },
        id: '123',
        dateCreated: '2024-10-08T17:27:14.705Z',
        dateModified: '2024-10-08T17:27:14.705Z',
        status: 'Active',
        createdBy: '',
        createdByIp: '',
        modifiedBy: '',
        modifiedByIp: '',
        serviceCategory: {
            name: 'Insurance',
            code: '',
            description: ''
        },
        serviceProvider: {
            code: '',
            companyName: 'Bankingly',
            description: '',
            websiteURL: '',
            logo: '',
            expenseGl: ''
        },
        integrationStatus: ''
    },
    {
        serviceCategoryId: '',
        serviceProviderId: '',
        name: 'Bankingly',
        description: 'Bankingly online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        features: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor',
        logo: '',
        logoUrl: BankinglyIcon,
        tooltip: '',
        screenshots: '',
        screenshotUrls: [],
        configureSetupFee: false,
        setupFee: 600,
        usageGuide: 'www.usageguide.com',
        termsAndConditions: '',
        isPublished: false,
        websiteUrl: 'www.test.com',
        installed: false,
        productStatistic: {
            productId: '',
            installation: 0,
            averageRating: 3,
            totalRatings: 0,
            numberOfRatings: 0,
            id: '',
            dateCreated: '2024-10-08T17:27:14.705Z',
            dateModified: '2024-10-08T17:27:14.705Z',
            status: '',
            createdBy: '',
            createdByIp: '',
            modifiedBy: '',
            modifiedByIp: ''
        },
        id: '124',
        dateCreated: '2024-10-08T17:27:14.705Z',
        dateModified: '2024-10-08T17:27:14.705Z',
        status: 'Active',
        createdBy: '',
        createdByIp: '',
        modifiedBy: '',
        modifiedByIp: '',
        serviceCategory: {
            name: 'Insurance',
            code: '',
            description: ''
        },
        serviceProvider: {
            code: '',
            companyName: 'Bankingly',
            description: '',
            websiteURL: '',
            logo: '',
            expenseGl: ''
        },
        integrationStatus: ''
    },
    {
        serviceCategoryId: '',
        serviceProviderId: '',
        name: 'Qoreid',
        description: 'QoreId online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        features: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor',
        logo: '',
        logoUrl: QoreidIcon,
        tooltip: '',
        screenshots: '',
        screenshotUrls: [],
        configureSetupFee: false,
        setupFee: 600,
        usageGuide: 'www.usageguide.com',
        termsAndConditions: '',
        isPublished: true,
        websiteUrl: 'www.test.com',
        installed: false,
        productStatistic: {
            productId: '',
            installation: 0,
            averageRating: 5,
            totalRatings: 0,
            numberOfRatings: 0,
            id: '',
            dateCreated: '2024-10-08T17:27:14.705Z',
            dateModified: '2024-10-08T17:27:14.705Z',
            status: '',
            createdBy: '',
            createdByIp: '',
            modifiedBy: '',
            modifiedByIp: ''
        },
        id: '125',
        dateCreated: '2024-10-08T17:27:14.705Z',
        dateModified: '2024-10-08T17:27:14.705Z',
        status: 'Inactive',
        createdBy: '',
        createdByIp: '',
        modifiedBy: '',
        modifiedByIp: '',
        serviceCategory: {
            name: 'Insurance',
            code: '',
            description: ''
        },
        serviceProvider: {
            code: '',
            companyName: 'Qoreid',
            description: '',
            websiteURL: '',
            logo: '',
            expenseGl: ''
        },
        integrationStatus: ''
    },
    {
        serviceCategoryId: '',
        serviceProviderId: '',
        name: 'Bankingly',
        description: 'Bankingly online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        features: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor',
        logo: '',
        logoUrl: BankinglyIcon,
        tooltip: '',
        screenshots: '',
        screenshotUrls: [],
        configureSetupFee: false,
        setupFee: 600,
        usageGuide: 'www.usageguide.com',
        termsAndConditions: '',
        isPublished: false,
        websiteUrl: 'www.test.com',
        installed: false,
        productStatistic: {
            productId: '',
            installation: 0,
            averageRating: 3,
            totalRatings: 0,
            numberOfRatings: 0,
            id: '',
            dateCreated: '2024-10-08T17:27:14.705Z',
            dateModified: '2024-10-08T17:27:14.705Z',
            status: '',
            createdBy: '',
            createdByIp: '',
            modifiedBy: '',
            modifiedByIp: ''
        },
        id: '126',
        dateCreated: '2024-10-08T17:27:14.705Z',
        dateModified: '2024-10-08T17:27:14.705Z',
        status: 'Active',
        createdBy: '',
        createdByIp: '',
        modifiedBy: '',
        modifiedByIp: '',
        serviceCategory: {
            name: 'Insurance',
            code: '',
            description: ''
        },
        serviceProvider: {
            code: '',
            companyName: 'Bankingly',
            description: '',
            websiteURL: '',
            logo: '',
            expenseGl: ''
        },
        integrationStatus: ''
    },
    {
        serviceCategoryId: '',
        serviceProviderId: '',
        name: 'Bankingly',
        description: 'Bankingly online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        features: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor',
        logo: '',
        logoUrl: BankinglyIcon,
        tooltip: '',
        screenshots: '',
        screenshotUrls: [],
        configureSetupFee: false,
        setupFee: 600,
        usageGuide: 'www.usageguide.com',
        termsAndConditions: '',
        isPublished: false,
        websiteUrl: 'www.test.com',
        installed: false,
        productStatistic: {
            productId: '',
            installation: 0,
            averageRating: 4,
            totalRatings: 0,
            numberOfRatings: 0,
            id: '',
            dateCreated: '2024-10-08T17:27:14.705Z',
            dateModified: '2024-10-08T17:27:14.705Z',
            status: '',
            createdBy: '',
            createdByIp: '',
            modifiedBy: '',
            modifiedByIp: ''
        },
        id: '127',
        dateCreated: '2024-10-08T17:27:14.705Z',
        dateModified: '2024-10-08T17:27:14.705Z',
        status: 'Active',
        createdBy: '',
        createdByIp: '',
        modifiedBy: '',
        modifiedByIp: '',
        serviceCategory: {
            name: 'Insurance',
            code: '',
            description: ''
        },
        serviceProvider: {
            code: '',
            companyName: 'Bankingly',
            description: '',
            websiteURL: '',
            logo: '',
            expenseGl: ''
        },
        integrationStatus: ''
    },
    {
        serviceCategoryId: '',
        serviceProviderId: '',
        name: 'Qoreid',
        description: 'QoreId online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        features: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor',
        logo: '',
        logoUrl: QoreidIcon,
        tooltip: '',
        screenshots: '',
        screenshotUrls: [],
        configureSetupFee: false,
        setupFee: 600,
        usageGuide: 'www.usageguide.com',
        termsAndConditions: '',
        isPublished: true,
        websiteUrl: 'www.test.com',
        installed: false,
        productStatistic: {
            productId: '',
            installation: 0,
            averageRating: 4,
            totalRatings: 0,
            numberOfRatings: 0,
            id: '',
            dateCreated: '2024-10-08T17:27:14.705Z',
            dateModified: '2024-10-08T17:27:14.705Z',
            status: '',
            createdBy: '',
            createdByIp: '',
            modifiedBy: '',
            modifiedByIp: ''
        },
        id: '128',
        dateCreated: '2024-10-08T17:27:14.705Z',
        dateModified: '2024-10-08T17:27:14.705Z',
        status: 'Inactive',
        createdBy: '',
        createdByIp: '',
        modifiedBy: '',
        modifiedByIp: '',
        serviceCategory: {
            name: '',
            code: '',
            description: ''
        },
        serviceProvider: {
            code: '',
            companyName: 'Qoreid',
            description: '',
            websiteURL: '',
            logo: '',
            expenseGl: ''
        },
        integrationStatus: ''
    }
]

export const products = [
    {
        id: 123,
        name: 'Bankingly',
        icon: BankinglyIcon,
        setupFee: '600',
        isPublished: false,
        description: 'Bankingly online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        rating: 4,
        status: 'Active',
        screenshotUrls: [
            Screenshot1,
            Screenshot2,
            Screenshot3,
            Screenshot4
        ]
    },
    {
        id: 125,
        name: 'Qoreid',
        icon: QoreidIcon,
        setupFee: '600',
        isPublished: true,
        description: 'QoreId online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        rating: 4,
        status: 'Inactive',
        screenshotUrls: [
            Screenshot1,
            Screenshot2,
            Screenshot3,
            Screenshot4
        ]
    },
    {
        id: 124,
        name: 'Bankingly',
        icon: BankinglyIcon,
        setupFee: '600',
        isPublished: false,
        description: 'Bankingly online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        rating: 4,
        status: 'Active',
        screenshotUrls: [
            Screenshot1,
            Screenshot2,
            Screenshot3,
            Screenshot4
        ]
    },
    {
        id: 126,
        name: 'Ebanqo',
        icon: EbanqoIcon,
        setupFee: '600',
        isPublished: false,
        description: 'Ebanqo online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        rating: 4,
        status: 'Active',
        screenshotUrls: [
            Screenshot1,
            Screenshot2,
            Screenshot3,
            Screenshot4
        ]
    },
    {
        id: 127,
        name: 'Qoreid',
        icon: QoreidIcon,
        setupFee: '600',
        isPublished: true,
        description: 'QoreId online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        rating: 4,
        status: 'Inactive',
        screenshotUrls: [
            Screenshot1,
            Screenshot2,
            Screenshot3,
            Screenshot4
        ]
    },
    {
        id: 128,
        name: 'Ebanqo',
        icon: EbanqoIcon,
        setupFee: '600',
        isPublished: false,
        description: 'Ebanqo online accounting software connects you to your bank, accountant, bookkeeper and other businesses.',
        rating: 4,
        status: 'Active',
        screenshotUrls: [
            Screenshot1,
            Screenshot2,
            Screenshot3,
            Screenshot4
        ]
    },
]

export const dashboardApps = {
    mostInstalled: [
        {
            name: 'Qoreid',
            logo: QoreidLogoSm,
            installationNumber: 6
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            installationNumber: 6
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            installationNumber: 6
        },
        {
            name: 'Ebanqo',
            logo: EbanqoLogoSm,
            installationNumber: 6
        },
        {
            name: 'Qoreid',
            logo: QoreidLogoSm,
            installationNumber: 6
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            installationNumber: 6
        },
        {
            name: 'Ebanqo',
            logo: EbanqoLogoSm,
            installationNumber: 6
        },
        {
            name: 'Qoreid',
            logo: QoreidLogoSm,
            installationNumber: 6
        }
    ],
    leastInstalled: [
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            installationNumber: 6
        },
        {
            name: 'Qoreid',
            logo: QoreidLogoSm,
            installationNumber: 6
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            installationNumber: 6
        },
        {
            name: 'Qoreid',
            logo: QoreidLogoSm,
            installationNumber: 6
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            installationNumber: 6
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            installationNumber: 6
        },
        {
            name: 'Qoreid',
            logo: QoreidLogoSm,
            installationNumber: 6
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            installationNumber: 6
        }
    ],
    highestGeneratedRevenue: [
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            amount: 3000000
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            amount: 3000000
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            amount: 3000000
        },
        {
            name: 'Qoreid',
            logo: QoreidLogoSm,
            amount: 3000000
        },
        {
            name: 'Qoreid',
            logo: QoreidLogoSm,
            amount: 3000000
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            amount: 3000000
        },
        {
            name: 'Qoreid',
            logo: QoreidLogoSm,
            amount: 3000000
        },
        {
            name: 'Qoreid',
            logo: QoreidLogoSm,
            amount: 3000000
        }
    ],
    serviceReliablity: [
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            noOfSuccessfulApiCall: 5,
            noOfFailedApiCall: 2
        },
        {
            name: 'Qoreid',
            logo: QoreidLogoSm,
            noOfSuccessfulApiCall: 5,
            noOfFailedApiCall: 2
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            noOfSuccessfulApiCall: 5,
            noOfFailedApiCall: 2
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            noOfSuccessfulApiCall: 5,
            noOfFailedApiCall: 2
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            noOfSuccessfulApiCall: 5,
            noOfFailedApiCall: 2
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            noOfSuccessfulApiCall: 5,
            noOfFailedApiCall: 2
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            noOfSuccessfulApiCall: 5,
            noOfFailedApiCall: 2
        },
        {
            name: 'Bankingly',
            logo: BankinglyLogoSm,
            noOfSuccessfulApiCall: 5,
            noOfFailedApiCall: 2
        }
    ]
}

export const comments = [
    {
        fullName: 'Iyin Laditan',
        rating: 4,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    },
    {
        fullName: 'Ridwan Kolawole',
        rating: 3,
        comment: 'Amazing!!!',
        date: '2024-08-02T16:55:23.957Z'
    }
]


export const availabilityStatus = [
    {
        id: 1,
        value: 'Available',
        label: 'Available'
    },
    {
        id: 2,
        value: 'notAvailable',
        label: 'Not Available'
    }
]
export const sampleSearchedData = [
    {label: 'Guaranty Trust', value: 'GTB'},
    {label: 'Access Bank', value: 'Access'},
    {label: 'First Bank', value: 'First'}
]
